module.exports = __webpack_public_path__ + "static/media/event.4bc5cab5.svg";